import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import SelectAsync from 'react-select/async';

export default class UnitBills extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'expensebillunit',
            caller: props.Caller,
            type: props.Type,
            data: null,
            loading: true,
            filters: {
                forMe: this.isNull(props.ForMe) ? true : props.ForMe,
                buildingId: this.getDefaultGuid(),
                expenseId: this.getDefaultGuid(),
                unitId: this.getDefaultGuid(),
                billId: this.getDefaultGuid()
            },
            systemModuleId: 29,
            moduleAccessStatus: 1,
            page: 1,
            per_page: 30,
            phrase: '',
            autoSettlement: false,
            autoSettlementDescription: '',
            autoSettlementNote: '',
            autoSettlementMoeinCode: 0
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;

                this.refreshData();
            });
    }
    componentWillReceiveProps(props) {
        if (props.ForMe == this.state.filters.forMe) return;
        this.state.filters.forMe = props.ForMe;
        this.refreshData();
    }
    setFilter(f, e) {
        if (this.isNull(e)) this.state.filters[f] = this.getDefaultGuid()
        else this.state.filters[f] = e.value;
        this.setState({ filters: this.state.filters });
    }
    autoSettlement() {
        this.setState({ autoSettlement: true });
    }
    saveAutoSettlement() {
        this.httpPost("api/v1/receipt/autosettlement/unitbills", {
            id: this.getDefaultGuid(),
            organizationId: this.state.data.global.company.id,
            description: this.state.autoSettlementDescription,
            note: this.state.autoSettlementNote,
            moeinCode: this.state.autoSettlementMoeinCode,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("عملیات با موفقیت انجام پذیرفت");
                    this.state.refreshData();
                    this.setState({
                        autoSettlement: false,
                        autoSettlementDescription: '',
                        autoSettlementNote: '',
                        autoSettlementMoeinCode: 0
                    });
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            {this.state.filters.forMe ? <h3 className="nk-block-title page-title">فهرست صورتحسابها من</h3>
                                : <h3 className="nk-block-title page-title">فهرست صورتحسابهای واحدها</h3>}
                            <div className="nk-block-des text-soft">
                                <p>{this.money(this.state.data.recordsCount)} صورتحساب یافت شد</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        {!this.state.filters.forMe && <li>
                                            <a onClick={e => this.autoSettlement()} className="hand btn btn-warning"><span>تسویه دسته جمعی</span></a>
                                        </li>}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.autoSettlement && <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner position-relative card-tools-toggle">
                                <p>با انتخاب تسویه دسته جمعی، مانده صورتحسابهای اشخاص، بر اساس مانده حساب اشخاص ها تسویه خواهد شد</p>
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="form-group">
                                                <label for="name" className="title1">حساب معین:</label>
                                                <SelectAsync
                                                    style={{ "width": "100%" }}
                                                    isMulti={false}
                                                    placeholder="انتخاب معین"
                                                    defaultOptions
                                                    loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3)}
                                                    onChange={e => this.state.autoSettlementMoeinCode = e.fullCode}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label for="name" className="title1">شرح سند:</label>
                                                <input
                                                    className="form-control"
                                                    placeholder="شرح"
                                                    defaultValue={e => this.state.autoSettlementDescription = e.target.value}
                                                    onChange={e => this.state.autoSettlementDescription = e.target.value}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label for="name" className="title1">یادداشت:</label>
                                                <input
                                                    className="form-control"
                                                    placeholder="یادداشت"
                                                    defaultValue={e => this.state.autoSettlementNote = e.target.value}
                                                    onChange={e => this.state.autoSettlementNote = e.target.value}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 mt-2">
                                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.setState({ autoSettlement: false })}>انصراف</button>
                                            <button onClick={e => this.saveAutoSettlement()} type="submit" className="btn btn-success hand ms-2">تسویه</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            {!this.state.filters.forMe && <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="form-wrap">
                                                <SelectAsync
                                                    //defaultValue={this.state.data.record.billExpenseId != this.getDefaultGuid() ? [{ value: this.state.data.record.billExpenseId, label: this.state.data.record.billEexpenseAutoDescription }] : null}
                                                    isMulti={false}
                                                    placeholder="انتخاب مجتمع"
                                                    defaultOptions
                                                    loadOptions={(inputValue, callback) => this.loadBuildingsOptions(inputValue, callback, 0)}
                                                    isClearable={true}
                                                    onChange={e => this.setFilter('buildingId', e)}
                                                />
                                            </div>
                                            {this.state.filters.buildingId !== this.getDefaultGuid() && <div className="form-wrap">
                                                <SelectAsync
                                                    //defaultValue={this.state.data.record.billExpenseId != this.getDefaultGuid() ? [{ value: this.state.data.record.billExpenseId, label: this.state.data.record.billEexpenseAutoDescription }] : null}
                                                    isMulti={false}
                                                    placeholder="انتخاب واحد"
                                                    defaultOptions
                                                    loadOptions={(inputValue, callback) => this.loadBuildingUnitsOptions(inputValue, callback, this.state.filters.buildingId, 0)}
                                                    isClearable={true}
                                                    onChange={e => this.setFilter('unitId', e)}
                                                />
                                            </div>}
                                            {this.state.filters.buildingId !== this.getDefaultGuid() && <div className="form-wrap">
                                                <SelectAsync
                                                    //defaultValue={this.state.data.record.billExpenseId != this.getDefaultGuid() ? [{ value: this.state.data.record.billExpenseId, label: this.state.data.record.billEexpenseAutoDescription }] : null}
                                                    isMulti={false}
                                                    placeholder="موضوع صورتحساب"
                                                    defaultOptions
                                                    loadOptions={(inputValue, callback) => this.loadBillExpensesOptions(inputValue, callback, this.state.filters.buildingId, 0, this.getDefaultGuid())}
                                                    isClearable={true}
                                                    onChange={e => this.setFilter('billId', e)}
                                                />
                                            </div>}
                                            <div className="form-wrap">
                                                <SelectAsync
                                                    //defaultValue={this.state.data.record.billExpenseId != this.getDefaultGuid() ? [{ value: this.state.data.record.billExpenseId, label: this.state.data.record.billEexpenseAutoDescription }] : null}
                                                    isMulti={false}
                                                    placeholder="نوع صورتحساب"
                                                    defaultOptions
                                                    loadOptions={(inputValue, callback) => this.loadExpensesOptions(inputValue, callback, [5, 6], 0)}
                                                    isClearable={true}
                                                    onChange={e => this.setFilter('expenseId', e)}
                                                />
                                            </div>
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>}
                            {this.state.data.recordsCount <= 0 ?
                                <div className="card-inner-group">
                                    <div className="example-alert">
                                        <div className="alert alert-pro alert-warning">
                                            <div className="alert-text">
                                                <h6>توجه</h6>
                                                <p>هیچ صورتحسابی یافت نشد</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col text-center"><span className="sub-text">ساختمان</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">شماره واحد</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">طبقه واحد</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">تاریخ</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">شرح</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">مبلغ کل صورتحساب</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">تخفیف</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">قابل پرداخت</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">مبلغ پرداخت شده</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">مبلغ باقی مانده</span></div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className="nk-tb-item">

                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">
                                                        {record.buildingTitle}
                                                    </span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">
                                                        {record.unitNumber}
                                                    </span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">
                                                        {record.floor}
                                                    </span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">
                                                        از {record.dateStartString} تا {record.dateEndString}
                                                    </span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">
                                                        {record.expensesType}
                                                    </span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{this.money(record.price)}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{this.money(record.discount)}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{this.money(record.total)}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{this.money(record.paiedPrice)}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{this.money(record.remainPrice)}</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                            {this.createPaging()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                this.renderPopupComponent(),
                <Footer />
            ];
        return contents;
    }
}